import React from "react"
import { useEffect, useRef, useState } from "react"

export default function FaqSegment(props) {
    const [active, setActive] = React.useState(0)


    const contentRef = useRef(null);

    useEffect(() => {
        contentRef.current.style.maxHeight = active
        ? `${contentRef.current.scrollHeight}px`
        : "0px";
    }, [contentRef, active]);

    const toggleAccordion = () => {
        setActive(!active);
    };

    return (
        <>
            <div className="aboutFaqElement" data-aos="fade-up" data-aos-once="true" data-aos-delay={props.delay} data-aos-offset={props.offset}>
                <div className="faqElementLine"></div>
                <div className="faqElementTextAlign" onClick={toggleAccordion}>
                    <p>{props.header}</p>
                    <div>
                        <i className={active ? "fa-solid fa-angle-up" : "fa-solid fa-angle-down"}></i>
                    </div>
                </div>
                <p ref={contentRef} className={active ? "faqElementDropdown faqElementDropdownActive" : "faqElementDropdown"}>{props.answer}</p>
            </div>
        </>
    )
}